import styled from "styled-components";
import { Button, Col } from 'reactstrap';

export const ContainerLayout = styled.div`
  position:relative;
`
// transition: ${(props) => (props.display ? "visibility 0s 2s, opacity 2s linear" : "opacity 2s linear")};

export const Banner = styled.div`
  visibility: ${(props) => (props.display ? "hidden" : "visible")};
  background-color: white;
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: auto;
  padding: 1rem 0 1rem 0;
  box-shadow: rgba(17, 17, 26, 0.5) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
`;
export const Text = styled(Col)`
  text-align: center;
  margin: 1rem auto 1rem auto;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    margin: auto;
    text-align: left;
  }
`
export const BtnDiv = styled(Col)`
  text-align: center;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    text-align: right;
  }
`

export const Btn = styled(Button)`
  width: 80%;
  background-color: ${({theme}) => theme.colors.mainBrown};
  border-color: ${({theme}) => theme.colors.mainBrown};
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  letter-spacing: 1px;
  :hover{
      color: ${({theme}) => theme.colors.mainBrown};
      background-color: ${({theme}) => theme.colors.white};
  }   
`;
